import React from 'react';
import { Layout, Typography, Card, Space, Tag, Divider, Row, Col, Avatar, Timeline, Statistic, Button } from 'antd';
import { 
  GithubOutlined, 
  MailOutlined, 
  CodeOutlined, 
  UserOutlined, 
  RocketOutlined, 
  ClockCircleOutlined,
  LikeOutlined,
  ProjectOutlined,
  TrophyOutlined
} from '@ant-design/icons';
import ParticleBackground from './components/ParticleBackground';
import './App.css';

const { Header, Content, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

function App() {
  return (
    <Layout className="layout">
      <ParticleBackground />
      <Header style={{ 
        display: 'flex', 
        alignItems: 'center', 
        background: 'rgba(255, 255, 255, 0.9)', 
        backdropFilter: 'blur(8px)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)', 
        padding: '0 24px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%'
      }}>
        <div className="logo" style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff', display: 'flex', alignItems: 'center' }}>
          <CodeOutlined style={{ marginRight: '8px' }} />
          张宏毅
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <Space>
            <Button type="text" href="#about">关于我</Button>
            <Button type="text" href="#skills">技能</Button>
            <Button type="text" href="#experience">经历</Button>
            <Button type="text" href="#projects">项目</Button>
          </Space>
        </div>
      </Header>
      <Content style={{ padding: '0 24px', maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
        <div className="site-layout-content" style={{ padding: '24px', minHeight: 'calc(100vh - 134px)' }}>
          
          {/* 个人简介 */}
          <section id="about" className="section-profile" style={{ marginTop: '60px', marginBottom: '80px', textAlign: 'center' }}>
            <div className="avatar-container">
              <Avatar size={140} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff', marginBottom: '24px', boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)' }} />
            </div>
            <Title level={1} style={{ marginBottom: '16px' }}>你好，我是张宏毅</Title>
            <Title level={4} type="secondary" style={{ marginTop: 0, marginBottom: '32px', fontWeight: 'normal' }}>
              全栈开发工程师 / 技术爱好者 / 终身学习者
            </Title>
            <Paragraph style={{ fontSize: '18px', color: '#555', maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
              一名热爱技术的程序员。专注于前端开发与用户体验，致力于编写优雅、高效的代码。
              喜欢探索新技术，解决复杂问题，并不断提升自己的技术栈。我相信技术的力量可以改变世界，
              哪怕只是一点点。
            </Paragraph>
            <Space size="large" style={{ marginTop: '32px' }}>
              <Button type="primary" size="large" icon={<MailOutlined />} href="mailto:contact@example.com">联系我</Button>
              <Button size="large" icon={<GithubOutlined />} href="https://github.com" target="_blank">GitHub</Button>
            </Space>
          </section>

          {/* 数据统计 */}
          <section className="section-stats" style={{ marginBottom: '80px' }}>
            <Card bordered={false} style={{ background: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(10px)', borderRadius: '16px' }}>
              <Row gutter={16}>
                <Col span={6}>
                  <Statistic title="项目经验" value={15} prefix={<ProjectOutlined />} suffix="+" />
                </Col>
                <Col span={6}>
                  <Statistic title="代码贡献" value={50000} prefix={<CodeOutlined />} suffix="+" />
                </Col>
                <Col span={6}>
                  <Statistic title="获得点赞" value={1208} prefix={<LikeOutlined />} />
                </Col>
                <Col span={6}>
                  <Statistic title="咖啡消耗" value={999} prefix={<RocketOutlined />} suffix="杯" />
                </Col>
              </Row>
            </Card>
          </section>

          <Divider />

          {/* 技术栈 */}
          <section id="skills" className="section-skills" style={{ marginBottom: '80px', paddingTop: '40px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '48px' }}>技术能力</Title>
            <Row gutter={[24, 24]} justify="center">
              <Col xs={24} sm={12} md={8}>
                <Card title="前端开发" hoverable className="skill-card" headStyle={{ background: '#e6f7ff', color: '#1890ff' }}>
                  <Space size={[8, 12]} wrap>
                    <Tag color="blue">React</Tag>
                    <Tag color="cyan">JavaScript (ES6+)</Tag>
                    <Tag color="geekblue">TypeScript</Tag>
                    <Tag color="purple">HTML5/CSS3</Tag>
                    <Tag color="magenta">Ant Design</Tag>
                    <Tag color="volcano">Vue.js</Tag>
                    <Tag color="gold">Next.js</Tag>
                    <Tag color="lime">Tailwind CSS</Tag>
                  </Space>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Card title="后端与工具" hoverable className="skill-card" headStyle={{ background: '#f6ffed', color: '#52c41a' }}>
                  <Space size={[8, 12]} wrap>
                    <Tag color="green">Node.js</Tag>
                    <Tag color="lime">Express</Tag>
                    <Tag color="gold">Git</Tag>
                    <Tag color="orange">Webpack</Tag>
                    <Tag color="red">MySQL</Tag>
                    <Tag color="blue">Docker</Tag>
                    <Tag color="cyan">Nginx</Tag>
                    <Tag color="purple">Linux</Tag>
                  </Space>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Card title="软技能" hoverable className="skill-card" headStyle={{ background: '#fff7e6', color: '#fa8c16' }}>
                  <Space size={[8, 12]} wrap>
                    <Tag color="orange">团队协作</Tag>
                    <Tag color="gold">敏捷开发</Tag>
                    <Tag color="yellow">问题解决</Tag>
                    <Tag color="volcano">技术分享</Tag>
                    <Tag color="red">持续学习</Tag>
                  </Space>
                </Card>
              </Col>
            </Row>
          </section>

          {/* 工作经历 */}
          <section id="experience" className="section-experience" style={{ marginBottom: '80px', paddingTop: '40px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '48px' }}>工作经历</Title>
            <Row justify="center">
              <Col xs={24} md={18}>
                <Card bordered={false} style={{ background: 'rgba(255, 255, 255, 0.8)', backdropFilter: 'blur(10px)', borderRadius: '16px', padding: '24px' }}>
                  <Timeline mode="alternate">
                    <Timeline.Item label="2023 - 至今" color="green">
                      <Title level={5} style={{ margin: 0 }}>高级前端工程师</Title>
                      <Text type="secondary">某知名互联网公司</Text>
                      <Paragraph style={{ marginTop: '8px' }}>
                        负责核心业务线的前端架构设计与开发，推动团队技术栈升级，提升开发效率30%。
                      </Paragraph>
                    </Timeline.Item>
                    <Timeline.Item label="2021 - 2023" color="blue">
                      <Title level={5} style={{ margin: 0 }}>前端开发工程师</Title>
                      <Text type="secondary">创新科技初创企业</Text>
                      <Paragraph style={{ marginTop: '8px' }}>
                        从0到1搭建SaaS平台前端项目，负责多个关键模块的开发与维护。
                      </Paragraph>
                    </Timeline.Item>
                    <Timeline.Item label="2019 - 2021" color="gray">
                      <Title level={5} style={{ margin: 0 }}>初级开发工程师</Title>
                      <Text type="secondary">软件解决方案提供商</Text>
                      <Paragraph style={{ marginTop: '8px' }}>
                        参与企业级管理系统的开发，积累了扎实的业务开发经验。
                      </Paragraph>
                    </Timeline.Item>
                    <Timeline.Item dot={<ClockCircleOutlined style={{ fontSize: '16px' }} />}>
                      <Text>开启职业生涯...</Text>
                    </Timeline.Item>
                  </Timeline>
                </Card>
              </Col>
            </Row>
          </section>

          {/* 项目展示 */}
          <section id="projects" className="section-projects" style={{ marginBottom: '60px', paddingTop: '40px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '48px' }}>精选项目</Title>
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} lg={8}>
                <Card 
                  hoverable
                  cover={<div style={{ height: 160, background: 'linear-gradient(135deg, #1890ff 0%, #36cfc9 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CodeOutlined style={{ fontSize: 48, color: '#fff' }} /></div>}
                  actions={[
                    <GithubOutlined key="github" />,
                    <RocketOutlined key="demo" />,
                  ]}
                >
                  <Card.Meta
                    title="电商后台管理系统"
                    description="基于 React + Ant Design Pro 的企业级后台管理系统，包含权限管理、数据可视化等功能。"
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Card 
                  hoverable
                  cover={<div style={{ height: 160, background: 'linear-gradient(135deg, #722ed1 0%, #eb2f96 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><ProjectOutlined style={{ fontSize: 48, color: '#fff' }} /></div>}
                  actions={[
                    <GithubOutlined key="github" />,
                    <RocketOutlined key="demo" />,
                  ]}
                >
                  <Card.Meta
                    title="个人博客平台"
                    description="使用 Next.js + Node.js 构建的现代化博客平台，支持 Markdown 渲染、评论系统和 SEO 优化。"
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} lg={8}>
                <Card 
                  hoverable
                  cover={<div style={{ height: 160, background: 'linear-gradient(135deg, #fa8c16 0%, #fadb14 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><TrophyOutlined style={{ fontSize: 48, color: '#fff' }} /></div>}
                  actions={[
                    <GithubOutlined key="github" />,
                    <RocketOutlined key="demo" />,
                  ]}
                >
                  <Card.Meta
                    title="在线协作工具"
                    description="实时在线文档协作工具，支持多人同时编辑，基于 WebSocket 技术实现。"
                  />
                </Card>
              </Col>
            </Row>
          </section>

          {/* 备案信息 */}
          <div style={{ textAlign: 'center', marginTop: '100px', marginBottom: '20px', color: '#999' }}>
             <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" style={{ color: '#999', textDecoration: 'none' }}>
               蜀ICP备2025148598号-1
             </a>
          </div>
        </div>
      </Content>
      <Footer style={{ textAlign: 'center', background: 'transparent' }}>
        Zhang Hongyi ©{new Date().getFullYear()} Created with React & Ant Design
      </Footer>
    </Layout>
  );
}

export default App;
